import React, { Component } from 'react';

import {Typeahead} from 'react-bootstrap-typeahead';

import translator from '../../../components/localization/translator';


export default class InputWithLabel extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: this.props.value || ''
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.state.value) {
			this.setState({ value: nextProps.value });
			this.setState({restaurants: nextProps.restaurants || []});
		}
	}

	filterBy(item, value) {
		return item && item.name && item.name.toLowerCase().indexOf(value.text.toLowerCase()) > -1;
	}

	render() {
		const key = this.props.labelKey ? this.props.labelKey : 'name';
		const selected = [];
		if (this.state.value) {
			selected[0] = {};
			selected[0][key] = this.state.value;
		}
		const inputProps = this.props.inputProps || {};

		return (
			<Typeahead
				id={key}
				labelKey={key}
				emptyLabel={translator.translate('_no_restaurant_matches_')}
				selected={selected}
				className={inputProps.className}
				multiple={false}
				disabled={inputProps.disabled}
				options={this.props.items}
				filterBy={this.props.doNotFilter ? () => true : this.filterBy}
				placeholder={inputProps.placeholder}
				onChange={this.props.onChange}
				onInputChange={this.props.onInputChange}
				paginationText={translator.translate('_display_all_result_')}
				open={this.props.open}
				onFocus={this.props.onFocus}
				onBlur={this.props.onBlur}
			/>
		);
	}
}
